import React, { useEffect, useRef, useState } from 'react';

import './CarrierManager.css';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Skeleton,
  TextField,
  Typography,
  Grid,
  Divider,
  Avatar,
  IconButton,
  Alert
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {
  AddMoreRateRequest,
  GetQuoteDetail,
  LogTLCarrierReQuoteResponse,
  LogTLCarrierReScheduleResponse,
  LogTLCarrierResponse,
  UpdateTLShipment
} from '../../apis/Agency';
import CancelIcon from '@mui/icons-material/Cancel';

import { MetaTags } from 'react-meta-tags';
import { base_logo_url, base_url } from '../../apis/constants';
import { ErrorToast, successToast } from '../Toasts';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TodayIcon from '@mui/icons-material/Today';
import { useIsMobile } from '../IsMobileHook/IsMobileHook';
import { grey } from '@mui/material/colors';
import ShipmentDetailsComponent from '../../pages/ShipDetailsComponent';
import { ToastContainer } from 'react-toastify';

export default function CarrierManagerArea(props) {
  const isMobile = useIsMobile();

  // const sessionId = props?.location?.search?.split('?')[1].split('=')[1];
  const sessionId = new URLSearchParams(props?.location?.search).get('id');
  const quoteTypeQuery = props?.location?.pathname?.split('/')[2];

  const [userInput, setUserInput] = useState('');
  const [userInputArray, setUserInputArray] = useState([]);
  const [showInputValue, setShowInputValue] = useState(false);
  const [secondInputValue, setSecondIputValue] = useState('');
  const [shipmentsDetails, setShipmentsDetails] = useState({});
  const [charges, setCharges] = useState('');
  const [previousChargesRequote, setPreviousChargesRequote] = useState('');
  const [refPickNmb, setRefPickNmb] = useState('--select--');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [pickupDate, setPickupDate] = useState('');
  const [previousPickupDateReschedule, setPrevPickupDateReschedule] =
    useState('');
  const [
    previousEstimatedDeliveryDateReschedule,
    setPrevEstDeliveryDateReschedule
  ] = useState('');
  const [htmlApiRes, setHtmlApiRes] = useState('');
  const [shipperApiMsgs, setShipperApiMsgs] = useState('');
  const [isBookedCarrierSame, setIsBookedCarrierSame] = useState(false);
  const [carrierApiMsgs, setCarrierApiMsgs] = useState('');
  const [isCancelledCarrier, setIsCancelledCarrier] = useState(false);
  const [sessionIdForCarrier, setSessionIdForCarrier] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [chatLoader, setChatLoader] = useState(false);
  const [quoteLoader, setQuoteLoader] = useState(false);
  const [mainLoader, setMainLoader] = useState(false);
  const [expiryInMinutes, setExpiryInMinutes] = useState('');
  const [isBooked, setIsBooked] = useState(false);
  const [quoteApiError, setQuoteApiError] = useState('');
  const history = useHistory();
  const [timeExpired, setTimeExpired] = useState(false);
  const [showMoreRateBtn, setShowMoreRateBtn] = useState(false);
  const [localTimeState, setLocalTimeState] = useState('');
  const [addMoreRateDialog, setAddMoreRateDialog] = useState(false);
  const [quoteTitle, setQuoteTitle] = useState('');
  const dataFetchedRef = useRef(true);
  const [acknowledgeLoader, setAcknowledgeLoader] = useState(false);
  const [MCNumber, setMCNumber] = useState('');
  const [truckTailerNmb, setTruckTailerNmb] = useState('');
  const [CarrierName, setCarrierName] = useState('');
  function parseISODate(dateString) {
    const [datePart, timePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes, seconds] = timePart.split(':');
    const milliseconds = parseFloat(timePart.split('.')[1] || 0);

    return new Date(
      year,
      month - 1,
      day,
      hours,
      minutes,
      seconds,
      milliseconds
    );
  }
  const handleGetQuotedData = (apiRes, latestRates) => {
    setPickupDate(new Date(apiRes?.pickupDate));
    setPrevPickupDateReschedule(new Date(apiRes?.pickupDate));
    setDeliveryDate(new Date(apiRes?.expectedDeliveryDate));
    setPrevEstDeliveryDateReschedule(new Date(apiRes?.expectedDeliveryDate));
    setCharges(latestRates);
    setPreviousChargesRequote(latestRates);
  };

  const handleSuccessResponse = (apiRes, stateStatus) => {
    const isBookedApi =
      (apiRes.data.data.shipmentInfo.shipment.shipmentStatus !== 'Tendered' &&
        !quoteTypeQuery) ||
      apiRes.data.data.shipmentInfo.shipment.shipmentStatus === 'InTransit' ||
      apiRes.data.data.shipmentInfo.shipment.shipmentStatus === 'Delivered'
        ? true
        : false;

    // if (isBookedApi) {
    setTimeExpired(false);
    setIsBooked(isBookedApi);
    // }

    setHtmlApiRes(apiRes?.data?.data?.details);
    setShipperApiMsgs(apiRes?.data?.data?.details);
    const carrierData = apiRes?.data?.data?.details?.filter(
      items => items.actionByFlag.toLowerCase() === 'carrier'
    );
    const isCancelledCarrier = carrierData?.some(
      items => items.action === 'CANCELLED' || false
    );
    setIsCancelledCarrier(isCancelledCarrier);
    const isBookedCarrier = carrierData?.find(
      items =>
        items.carrierId === apiRes.data.data.shipmentInfo?.shipment?.carrierId
    );
    setIsBookedCarrierSame(isBookedCarrier);
    setCarrierApiMsgs(carrierData);
    console.log(stateStatus, 'stateStatus');
    if (
      (dataFetchedRef.current && quoteTypeQuery) ||
      stateStatus === 'maintainPrevState'
    ) {
      const lastMsgRate = carrierData[carrierData.length - 1].actionValue;
      handleGetQuotedData(
        apiRes?.data?.data?.shipmentInfo?.shipment,
        lastMsgRate
      );
      dataFetchedRef.current = false;
    }

    const lastIndex = apiRes?.data?.data?.length - 1;
    const expireyTime = apiRes?.data?.data?.details[0]?.date;
    setShipmentsDetails(apiRes?.data?.data?.shipmentInfo);
    setQuoteTitle(apiRes?.data?.data?.title);
    setChatLoader(false);
    setMainLoader(false);
    setExpiryInMinutes(apiRes?.data?.data?.expiryInMinutes);

    const utcTimeString = expireyTime + 'Z';
    const utcDate = new Date(utcTimeString);

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localTime = new Intl.DateTimeFormat('default', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: userTimeZone
    }).format(utcDate);

    const finalTime = parseISODate(expireyTime);
    setLocalTimeState(localTime);
  };

  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    // replace this with your specific time
    const checkTimePassed = () => {
      if (localTimeState) {
        const currentTime = new Date();
        const startTime = new Date(localTimeState);
        const timeDifference = currentTime - startTime;
        const thirtyMinutesInMilliseconds = 60 * 60 * 1000; // 30 minutes in milliseconds

        if (timeDifference >= thirtyMinutesInMilliseconds) {
          // Time has expired
          setTimeExpired(true);
        }
      }
    };

    // Check time when the component mounts
    checkTimePassed();

    // Set up an interval to check the time every minute (adjust as needed)
    const intervalId = setInterval(checkTimePassed, 1 * 1000);

    // Clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [localTimeState]);

  useEffect(() => {
    const interval = setInterval(() => {
      CarrierQuoteReqHandler(sessionId);
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [sessionId]);

  const CarrierQuoteReqHandler = (sessionId, stateStatus) => {
    // setDeliveryDate('');
    // setCharges(0);
    // setRefPickNmb('');
    GetQuoteDetail(sessionId, stateStatus)
      .then(
        res => res.status === 200 && handleSuccessResponse(res, stateStatus)
      )
      .catch(error => {
        if (error.response?.status === 403) {
          console.error('403 - Forbidden:', error.response.data);
          // maybe redirect to login or show message
        } else {
          console.error('API error:', error);
          setMainLoader(false);
          setQuoteApiError(error?.message);
        }
      });
  };

  useEffect(() => {
    setMainLoader(true);
    // const sessionId = props?.location?.search?.split('?')[1].split('=')[1];
    setSessionIdForCarrier(sessionId);
    CarrierQuoteReqHandler(sessionId);
  }, []);

  const handleUserInput = input => {
    setUserInput(input);
  };

  const handleShowUserInputMsgs = type => {
    // setShowInputValue(true);
    if (type === '2ndInput') {
      if (!charges) {
        validationErrors['charges'] = 'Enter Charges';
      }
      // else if (refPickNmb === '--select--') {
      //   validationErrors['serviceType'] = 'Select service type';
      // }
      else if (!pickupDate) {
        validationErrors['pickupDate'] = 'Select Pickup Date';
      } else if (!deliveryDate) {
        validationErrors['deliveryDate'] = 'Select Estimated Delivery Date';
      }
      setValidationErrors(validationErrors);
    }
    let temp = [...userInputArray];
    temp.push({ msg: userInput });
    setUserInputArray(temp);
    getCurrentDateTime();
    setUserInput('');

    const logTlRequestDateHandler = dateString => {
      const date = new Date(dateString);

      // Extracting date components
      const year = date.getFullYear();
      const month = date.toLocaleString('default', { month: 'numeric' });
      const day = date.getDate();

      // Creating formatted date string
      const formattedDate = `${year}-${month}-${day}`;

      return formattedDate;
    };
    if (type === '1stInput') {
      setChatLoader(true);

      const chatObj = {
        sessionId: sessionIdForCarrier,
        charges: 0,
        pickupNumber: '',
        pickupDate: logTlRequestDateHandler(pickupDate),
        estimatedDeliveryDate: logTlRequestDateHandler(deliveryDate),
        comments: userInput
      };
      LogTLCarrierResponse(chatObj)
        .then(res => {
          res.status === 200 && setShowMoreRateBtn(true);
          CarrierQuoteReqHandler(sessionIdForCarrier);
        })
        .catch(err => {
          setChatLoader(false);
          setShowMoreRateBtn(false);
        });
    }

    if (type === '2ndInput' && charges && pickupDate && deliveryDate) {
      setQuoteLoader(true);
      if (quoteTypeQuery === 'requote') {
        const requoteObj = {
          sessionId: sessionIdForCarrier ?? '',
          charges: charges
            ? Number(String(charges).replace(/[^0-9.]/g, ''))
            : 0,
          previousCharges: previousChargesRequote ?? 0,
          comments: secondInputValue ?? ''
        };

        LogTLCarrierReQuoteResponse(requoteObj)
          .then(res => {
            res.status === 200 && setQuoteLoader(false);
            setShowMoreRateBtn(true);
            CarrierQuoteReqHandler(sessionIdForCarrier, 'maintainPrevState');
          })
          .catch(err => {
            setQuoteLoader(false);
            setChatLoader(false);
            setShowMoreRateBtn(false);
          });
      }
      if (quoteTypeQuery === 'reschedule') {
        const rescheduleObj = {
          sessionId: sessionIdForCarrier,
          charges: charges
            ? Number(String(charges).replace(/[^0-9.]/g, ''))
            : 0,
          pickupDate: logTlRequestDateHandler(pickupDate),
          estimatedDeliveryDate: logTlRequestDateHandler(deliveryDate),
          comments: secondInputValue ?? '',
          previousPickupDate:
            logTlRequestDateHandler(previousPickupDateReschedule) ?? '',
          previousEstimatedDeliveryDate:
            logTlRequestDateHandler(previousEstimatedDeliveryDateReschedule) ??
            ''
        };
        LogTLCarrierReScheduleResponse(rescheduleObj)
          .then(res => {
            res.status === 200 && setQuoteLoader(false);
            setShowMoreRateBtn(true);
            CarrierQuoteReqHandler(sessionIdForCarrier, 'maintainPrevState');
          })
          .catch(err => {
            setQuoteLoader(false);
            setChatLoader(false);
            setShowMoreRateBtn(false);
          });
      } else if (!quoteTypeQuery) {
        const chatObj = {
          sessionId: sessionIdForCarrier,
          charges: charges
            ? Number(String(charges).replace(/[^0-9.]/g, ''))
            : 0,
          pickupNumber: '',
          pickupDate: logTlRequestDateHandler(pickupDate),
          estimatedDeliveryDate: logTlRequestDateHandler(deliveryDate),
          comments: secondInputValue
        };
        LogTLCarrierResponse(chatObj)
          .then(res => {
            res.status === 200 && setQuoteLoader(false);
            setShowMoreRateBtn(true);
            CarrierQuoteReqHandler(sessionIdForCarrier);
          })
          .catch(err => {
            setQuoteLoader(false);

            setQuoteLoader(false);
            setShowMoreRateBtn(false);
          });
      }
    }
  };
  const handleKeyDown = (e, type) => {
    console.log(e, type, 'e, type');
    if (e.key === 'Enter') {
      handleShowUserInputMsgs(type);
    }
  };
  const bottomRef = useRef(null);

  const scrollToBottom = () => {
    bottomRef.current &&
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const prevLengthRef = useRef(0);

  useEffect(() => {
    if (shipperApiMsgs.length > prevLengthRef.current) {
      scrollToBottom(); // scroll only on new message
    }
    prevLengthRef.current = shipperApiMsgs.length;
  }, [shipperApiMsgs]);
  const getOrdinal = n => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const totalPieces =
    shipmentsDetails?.details?.length > 0 &&
    shipmentsDetails?.details.reduce(
      (sum, item) =>
        sum + Number(item.itemType === 'Pickup' ? item.pallets || 0 : 0),
      0
    );
  const pickups =
    shipmentsDetails?.details?.length > 0 &&
    shipmentsDetails?.details?.filter(item => item.itemType === 'Pickup');

  const deliveries =
    shipmentsDetails?.details?.length > 0 &&
    shipmentsDetails?.details?.filter(item => item.itemType === 'Delivery');
  const groupedPickupDetails =
    pickups &&
    pickups.reduce((acc, item) => {
      const key = `${item.address}-${item.city}-${item.state}-${item.zip}-${item.country}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

  const groupedDeliveryDetails =
    deliveries &&
    deliveries.reduce((acc, item) => {
      const key = `${item.address}-${item.city}-${item.state}-${item.zip}-${item.country}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

  const getCurrentDateTime = (() => {
    let initialTimestamp = null;

    return () => {
      if (!initialTimestamp) {
        initialTimestamp = new Date();
        let temp = [...userInputArray];
        temp.push({ timeStamp: initialTimestamp, msg: userInput });
        // temp.push({ msg: userInput });
        setUserInputArray(temp);
      }

      const now = new Date();
      const diff = now - initialTimestamp;

      const daysOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ];
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'July',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ];

      const dayName = daysOfWeek[initialTimestamp.getDay()];
      const monthName = months[initialTimestamp.getMonth()];
      const day = initialTimestamp.getDate();
      const year = initialTimestamp.getFullYear();

      const hours = initialTimestamp.getHours();
      const minutes = initialTimestamp.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      const formattedTime = `${hours % 12 || 12}:${
        minutes < 10 ? '0' : ''
      }${minutes} ${ampm}`;
      let temp = [...userInputArray];
      temp.push({
        timeStamp: ` ${monthName} ${day}, ${year} ${formattedTime}`,
        msg: userInput
      });
      // temp.push({ msg: userInput });
      setUserInputArray(temp);
      // return ` ${monthName} ${day}, ${year} ${formattedTime}`;
    };
  })();
  const handleDateTimeShow = (timeStamp, type) => {
    const dateTimeString = timeStamp + 'Z';
    const dateTime = new Date(dateTimeString);
    const timeOptions = {
      hour: 'numeric',
      minute: '2-digit',
      // second: '2-digit',
      hour12: true,
      // weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const localTime = new Intl.DateTimeFormat('default', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: userTimeZone
    }).format(dateTime);
    if (type === 'time') {
      const formattedTime = dateTime.toLocaleTimeString(undefined, localTime);

      return localTime;
    }
  };

  const handleAddMoreRates = () => {
    AddMoreRateRequest(sessionId)
      .then(res => {
        res.status === 200 &&
          window.open(`/carrier-manager?sessionId=${res.data.data}`, '_blank');
      })
      .catch(err => ErrorToast(err?.message));
  };
  const handleCloseAddMoreDialog = () => {
    setAddMoreRateDialog(false);
  };
  const formatNumberWithCommas = value => {
    if (value === null || value === undefined || value === '') return '';

    const cleanedValue = String(value).replace(/,/g, '');

    if (!/^\d*\.?\d*$/.test(cleanedValue)) return value;

    const [integerPart, decimalPart] = cleanedValue.split('.');

    // Hide the "0" if user hasn't typed anything except maybe deleting
    if (
      integerPart === '' ||
      (integerPart === '0' && !decimalPart && value.length === 1)
    ) {
      return '';
    }

    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return decimalPart !== undefined
      ? `${formattedInt}.${decimalPart}`
      : formattedInt;
  };

  const handleAcknowledgeQuote = () => {
    const errors = {};

    if (!MCNumber) {
      errors.MCNumberError = 'Enter MC #';
    } else if (!truckTailerNmb) {
      errors.truckTailerNmbError = 'Enter Truck/ Trailer #';
    } else if (Object.keys(errors).length === 0) {
      setAcknowledgeLoader(true);

      const acknowledgeReqObj = {
        shipmentId: shipmentsDetails?.shipment?.id ?? 0,
        motorCarrierNumber: MCNumber ?? '',
        trailerNumber: truckTailerNmb ?? '',
        carrierName: CarrierName ?? ''
      };

      UpdateTLShipment(acknowledgeReqObj)
        .then(res => {
          res.status === 200 && setAcknowledgeLoader(false);
          successToast('Quote acknowledged successfully!');
        })
        .catch(err => {
          setAcknowledgeLoader(false);
          ErrorToast(err?.message);
        });
    }

    setValidationErrors(errors);
  };

  const handleDateChange = (userDate, type) => {
    const dateString = userDate;

    if (type === 'deliveryDate') {
      setDeliveryDate(userDate);
      setValidationErrors({
        ...validationErrors,
        deliveryDate: null
      });
    }
    if (type === 'pickupDate') {
      setPickupDate(userDate);
      setValidationErrors({
        ...validationErrors,
        pickupDate: null
      });
    }
  };

  return (
    <div className='Carrier_Manager_Parent'>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Dialog
        sx={isMobile ? {} : { minWidth: 400 }}
        open={addMoreRateDialog}
        onClose={handleCloseAddMoreDialog}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Do you want to add more rates ?
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={handleCloseAddMoreDialog}>
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={() => {
              handleAddMoreRates();
              handleCloseAddMoreDialog();
            }}
            // autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <MetaTags>
        <title>ShipTech Pro | Request for TL Quote</title>
        {/* <title>
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'ShipTech Pro - Request for TL Quote'
            : 'TMS - Request for TL Quote'}
        </title> */}
      </MetaTags>

      {showInputValue ? (
        <div
          className='Chat_Parent_Success'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f5f5f5'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <CheckCircleOutlineIcon
              sx={{ color: 'green', width: 130, height: 130 }}
            />
            <Typography color={'green'} variant='h4'>
              Quote sent to shipping Manager!
            </Typography>
          </div>
        </div>
      ) : mainLoader ? (
        <Box>
          <Skeleton sx={{ height: 80 }} />
          <Skeleton sx={{ height: 880, mt: -25 }} />
          <Box
            sx={{ mt: -20, display: 'flex', justifyContent: 'space-between' }}
          >
            <Skeleton sx={{ height: 40, width: 450 }} />
            <Skeleton sx={{ height: 40, width: 450 }} />
            <Skeleton sx={{ height: 40, width: 450 }} />
            <Skeleton sx={{ height: 40, width: 450 }} />
          </Box>
          <Skeleton sx={{ height: 70, mt: -2 }} />
        </Box>
      ) : (
        !isBooked &&
        !isCancelledCarrier && (
          <Grid
            container
            p={1}
            gap={2}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Grid item md={11} lg={5.9} xl={5.9}>
              <Grid
                sx={{
                  // backgroundColor: '#f1f7fe',
                  height: {
                    xs:
                      quoteTypeQuery === 'acknowledge'
                        ? 'calc(100vh - 100px)'
                        : 'calc(92vh - 100px)',
                    md:
                      quoteTypeQuery === 'acknowledge'
                        ? 'calc(100vh - 120px)'
                        : 'calc(92vh - 120px)',
                    lg:
                      quoteTypeQuery === 'acknowledge'
                        ? 'calc(100vh - 150px)'
                        : 'calc(92vh - 180px)'
                  },
                  overflowX: 'hidden',
                  overflowY: 'auto',
                  borderRadius: 2,
                  p: 1,
                  border: '1px solid',
                  borderColor: 'grey.300',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'grey.500',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
                  }
                }}
              >
                {/* <Typography
                  // onClick={handleSynchRatesRequest}
                  gutterBottom
                  sx={{
                    fontSize: '14px',
                    minWidth: 'auto',
                    textTransform: 'none'
                  }}
                  className='fw-bold'
                >
                  Shipment Details
                </Typography> */}

                <Grid
                  container
                  // spacing={2}
                  sx={{
                    backgroundColor: '#EEF4FC',
                    borderRadius: 2,
                    padding: 1,
                    mt: 1
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                      // gap: 1
                    }}
                  >
                    <Grid sx={{ display: 'flex' }}>
                      <div className='rating_scree_label'>
                        Total Net Weight (lbs)
                      </div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {formatNumberWithCommas(
                        shipmentsDetails?.shipment?.totalNetWeight
                      )}
                    </div>

                    <Grid sx={{ display: 'flex', mt: 1 }}>
                      <div className='rating_scree_label'>
                        Total Gross Weight (lbs)
                      </div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {formatNumberWithCommas(
                        shipmentsDetails?.shipment?.totalGrossWeight
                      )}
                    </div>

                    <Grid sx={{ display: 'flex', mt: 1 }}>
                      <div className='rating_scree_label'>Total # of Units</div>
                    </Grid>
                    <div className='rating_scree_value'>{totalPieces}</div>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center'
                      // gap: 1
                    }}
                  >
                    <Grid sx={{ display: 'flex' }}>
                      <div className='rating_scree_label'>Pickup Mode</div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {shipmentsDetails?.quoteMode}
                    </div>

                    <Grid sx={{ display: 'flex', mt: 1 }}>
                      <div className='rating_scree_label'>Equipment Type</div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {shipmentsDetails?.shipment?.equipmentType}{' '}
                      {shipmentsDetails?.shipment?.equipmentType === 'Reefer' &&
                        `(${shipmentsDetails?.temperature}${shipmentsDetails?.temperatureUnit})`}
                    </div>

                    <Grid sx={{ display: 'flex', mt: 1 }}>
                      <div className='rating_scree_label'>Service Type</div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {shipmentsDetails?.shipment?.serviceType}
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column'
                      // justifyContent: 'center'
                      // gap: 1
                    }}
                  >
                    <Grid sx={{ display: 'flex' }}>
                      <div className='rating_scree_label'>Quotation Number</div>
                    </Grid>
                    <div className='rating_scree_value'>
                      {shipmentsDetails?.quoteNumber}
                    </div>
                  </Grid>
                </Grid>
                {shipmentsDetails?.details?.length > 0 && (
                  <ShipmentDetailsComponent
                    shipmentsDetails={shipmentsDetails?.details}
                    groupedPickupDetails={groupedPickupDetails}
                    groupedDeliveryDetails={groupedDeliveryDetails}
                    previousRowDetails={shipmentsDetails?.shipment}
                    quoteMode={shipmentsDetails?.quoteMode}
                  />
                )}
              </Grid>

              <Grid sx={{ width: '100%' }}>
                {quoteTypeQuery === 'acknowledge' && (
                  <Grid container spacing={2} sx={{ display: 'flex', mt: 0.1 }}>
                    <Grid item xl={3.3} lg={3.3} md={3.3} sm={3.3} xs={12}>
                      <label
                        style={
                          validationErrors.MCNumberError ? { color: 'red' } : {}
                        }
                        htmlFor='MC #'
                      >
                        <b>
                          {validationErrors.MCNumberError
                            ? validationErrors.MCNumberError
                            : 'MC # *'}{' '}
                        </b>
                      </label>
                      <br />
                      <input
                        className={`carrier_input_style ${
                          validationErrors.MCNumberError
                            ? 'carrier_input_style_error'
                            : 'carrier_input_style'
                        }`}
                        placeholder='Enter MC #'
                        type='text'
                        id='MC #'
                        name='MC #'
                        onChange={e => {
                          const rawValue = e.target.value;
                          setValidationErrors({
                            ...validationErrors,
                            MCNumberError: null
                          });
                          setMCNumber(rawValue); // store as string
                        }}
                        value={MCNumber}
                      />
                    </Grid>

                    <Grid item xl={3.3} lg={3.3} md={3.3} sm={3.3} xs={12}>
                      <label
                        style={
                          validationErrors.truckTailerNmbError
                            ? { color: 'red' }
                            : {}
                        }
                        htmlFor='Trailer/ Truck # *'
                      >
                        <b>
                          {validationErrors.truckTailerNmbError
                            ? validationErrors.truckTailerNmbError
                            : 'Trailer/ Truck # *'}{' '}
                        </b>
                      </label>
                      <br />
                      <input
                        className={`carrier_input_style ${
                          validationErrors.truckTailerNmbError
                            ? 'carrier_input_style_error'
                            : 'carrier_input_style'
                        }`}
                        placeholder='Enter Trailer/ Truck #'
                        type='text'
                        id='Trailer/ Truck #'
                        name='Trailer/ Truck #'
                        onChange={e => {
                          const rawValue = e.target.value;
                          setValidationErrors({
                            ...validationErrors,
                            truckTailerNmbError: null
                          });
                          setTruckTailerNmb(rawValue); // store as string
                        }}
                        value={truckTailerNmb}
                      />
                    </Grid>
                    <Grid item xl={3.3} lg={3.3} md={3.3} sm={3.3} xs={12}>
                      <label
                        style={
                          validationErrors.CarrierName ? { color: 'red' } : {}
                        }
                        htmlFor='Carrier Name'
                      >
                        <b>
                          {validationErrors.CarrierName
                            ? validationErrors.CarrierName
                            : 'Carrier Name'}{' '}
                        </b>
                      </label>
                      <br />
                      <input
                        className={`carrier_input_style ${
                          validationErrors.CarrierName
                            ? 'carrier_input_style_error'
                            : 'carrier_input_style'
                        }`}
                        placeholder='Enter Carrier Name'
                        type='text'
                        id='Carrier Name'
                        name='Carrier Name'
                        onChange={e => {
                          const rawValue = e.target.value;
                          setValidationErrors({
                            ...validationErrors,
                            CarrierName: null
                          });
                          setCarrierName(rawValue);
                        }}
                        value={CarrierName}
                      />
                    </Grid>
                    <Grid
                      item
                      md={2.1}
                      lg={2.1}
                      xl={2.1}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <Button
                        disabled={acknowledgeLoader}
                        fullWidth
                        sx={{ mt: 2, borderRadius: 3 }}
                        onClick={() => handleAcknowledgeQuote()}
                        variant='contained'
                        color='success'
                      >
                        Acknowledge
                        {acknowledgeLoader && (
                          <CircularProgress
                            color='success'
                            sx={{
                              ml: 2
                            }}
                            size={22}
                          />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                )}

                {quoteTypeQuery !== 'acknowledge' && (
                  <>
                    <Grid
                      container
                      // gap={2}
                      spacing={2}
                      sx={{
                        mt: 0.1,
                        display: 'flex',
                        whiteSpace: 'nowrap',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
                        <label
                          style={
                            validationErrors.charges ? { color: 'red' } : {}
                          }
                          htmlFor='Charges $'
                        >
                          <b>
                            {validationErrors.charges
                              ? validationErrors.charges
                              : 'All in Freight Cost *'}{' '}
                          </b>
                        </label>
                        <br />
                        <input
                          disabled={
                            quoteTypeQuery === 'reschedule' ||
                            quoteTypeQuery === 'acknowledge'
                          }
                          className={`carrier_input_style ${
                            validationErrors.charges
                              ? 'carrier_input_style_error'
                              : 'carrier_input_style'
                          }`}
                          placeholder='$'
                          type='text'
                          id='Charges'
                          name='Charges'
                          value={
                            charges === ''
                              ? ''
                              : formatNumberWithCommas(charges)
                          }
                          onChange={e => {
                            const rawValue = e.target.value;

                            const cleanedValue = rawValue.replace(
                              /[^0-9.]/g,
                              ''
                            );

                            const validValue = cleanedValue.replace(
                              /(\..*)\./g,
                              '$1'
                            );

                            setValidationErrors(prev => ({
                              ...prev,
                              charges: null
                            }));
                            setCharges(validValue);
                          }}
                          onKeyDown={e => {
                            if (
                              !(
                                (e.key >= '0' && e.key <= '9') ||
                                e.key === 'Backspace' ||
                                e.key === 'Delete' ||
                                e.key === 'ArrowLeft' ||
                                e.key === 'ArrowRight' ||
                                e.key === 'Tab' ||
                                e.key === '.'
                              )
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onPaste={e => {
                            const paste = e.clipboardData.getData('text');
                            if (!/^[0-9.]+$/.test(paste)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                        <label
                          style={
                            validationErrors.pickupDate ? { color: 'red' } : {}
                          }
                          htmlFor='Pickup Date'
                        >
                          <b>
                            {validationErrors.pickupDate
                              ? validationErrors.pickupDate
                              : 'Pickup Date *'}{' '}
                          </b>
                        </label>
                        <br />

                        <DatePicker
                          disabled={
                            quoteTypeQuery === 'requote' ||
                            quoteTypeQuery === 'acknowledge'
                          }
                          wrapperClassName='datePicker'
                          todayButton={<TodayIcon />}
                          placeholderText='mm/dd/year'
                          className={`carrier_input_style ${
                            validationErrors.pickupDate
                              ? 'carrier_input_style_error'
                              : 'carrier_input_style'
                          }`}
                          // className='Rates_Input_delivery'
                          selected={pickupDate}
                          onChange={e => handleDateChange(e, 'pickupDate')}
                          minDate={new Date()}
                        />
                      </Grid>
                      <Grid item xl={3} lg={3} md={3} sm={3} xs={12}>
                        <label
                          style={
                            validationErrors.deliveryDate
                              ? { color: 'red' }
                              : {}
                          }
                          htmlFor='Delivery Date'
                        >
                          <b>
                            {validationErrors.deliveryDate
                              ? validationErrors.deliveryDate
                              : 'Estimated Delivery Date *'}{' '}
                          </b>
                        </label>
                        <br />

                        <DatePicker
                          disabled={
                            quoteTypeQuery === 'requote' ||
                            quoteTypeQuery === 'acknowledge'
                          }
                          wrapperClassName='datePicker'
                          todayButton={<TodayIcon />}
                          placeholderText='mm/dd/year'
                          style={
                            validationErrors.deliveryDate
                              ? {
                                  borderColor: 'red'
                                  // border: '2px solid red'
                                }
                              : {}
                          }
                          className={`carrier_input_style ${
                            validationErrors.deliveryDate
                              ? 'carrier_input_style_error'
                              : 'carrier_input_style'
                          }`}
                          // className='Rates_Input_delivery'
                          selected={
                            pickupDate > deliveryDate ? '' : deliveryDate
                          }
                          onChange={e => handleDateChange(e, 'deliveryDate')}
                          minDate={new Date(pickupDate)}
                        />
                      </Grid>
                      <Grid
                        item
                        md={3}
                        lg={3}
                        xl={3}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <Button
                          disabled={
                            quoteLoader || quoteTypeQuery === 'acknowledge'
                          }
                          fullWidth
                          sx={{ mt: 2, borderRadius: 3 }}
                          onClick={() => handleShowUserInputMsgs('2ndInput')}
                          variant='contained'
                          color='primary'
                        >
                          {quoteTypeQuery
                            ? 'Resubmit Quote'
                            : carrierApiMsgs.length > 0
                            ? 'Resubmit Quote'
                            : 'Submit Quote'}{' '}
                          {quoteLoader && (
                            <CircularProgress
                              color='success'
                              sx={{
                                ml: 2
                              }}
                              size={22}
                            />
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <Grid item md={12} lg={12} xl={12}>
                        <label>
                          <b>Notes / Terms</b>
                        </label>
                        <TextField
                          disabled={quoteTypeQuery === 'acknowledge'}
                          sx={{
                            // mt: 1,
                            backgroundColor: 'f1f7fe',
                            '& .MuiInputBase-root': {
                              display: 'flex',
                              alignItems: 'center',
                              paddingRight: '45px'
                            },
                            '& textarea': {
                              margin: 0,
                              padding: '12px 0 12px 0',
                              display: 'flex',
                              alignItems: 'center'
                            }
                          }}
                          size='small'
                          multiline
                          minRows={2}
                          fullWidth
                          type='text'
                          id='userInput'
                          name='userInput'
                          value={secondInputValue}
                          onChange={e => setSecondIputValue(e.target.value)}
                          placeholder='Enter any additional notes or terms'
                          onKeyDown={e => handleKeyDown(e, '2ndInput')}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>

            <Grid md={11} lg={5.9} xl={5.9}>
              <Grid
                sx={{
                  backgroundColor: '#f1f7fe',
                  height: {
                    xs: 'calc(92vh - 100px)',
                    md: 'calc(92vh - 120px)',
                    lg: 'calc(92vh - 75px)'
                  },
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'grey.300',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    borderColor: 'grey.500',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
                  }
                }}
              >
                <div
                  style={
                    isMobile
                      ? {
                          display: 'flex',
                          flexDirection: 'column',
                          margin: 4
                        }
                      : {
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          margin: 10
                        }
                  }
                >
                  <Typography
                    sx={
                      isMobile
                        ? { fontSize: 14 }
                        : { fontSize: 16, fontWeight: 500 }
                    }
                    variant='body2'
                  >
                    {/* ShipTech Pro - {quoteTitle} */}
                    Chat with Shipper Representative
                  </Typography>
                </div>

                <div className='Chat_Child'>
                  {shipperApiMsgs &&
                    shipperApiMsgs.map(carrierRes => (
                      <div
                        style={
                          carrierRes.actionByFlag.toLowerCase() === 'shipper'
                            ? {
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: 10,
                                marginRight: 10
                              }
                            : {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginLeft: 10,
                                marginRight: 10
                              }
                        }
                      >
                        <div>
                          {carrierRes.actionByFlag.toLowerCase() ===
                            'shipper' && (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'start'
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  marginLeft: 0,
                                  marginRight: 1,
                                  textAlign: 'left',
                                  marginBottom: 10
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: '#eceff1',
                                    borderRadius: '50%',
                                    width: '45',
                                    height: '45',
                                    textAlign: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginRight: 10
                                  }}
                                >
                                  <Avatar
                                    variant='circular'
                                    style={{
                                      borderRadius: '50%',
                                      width: '45',
                                      height: '45',
                                      textAlign: 'center',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      objectFit: 'cover'
                                    }}
                                    alt=''
                                    src={
                                      base_logo_url +
                                      shipperApiMsgs.find(
                                        items =>
                                          items.actionByFlag.toLowerCase() ===
                                          'shipper'
                                      )?.actionByImage
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                  }}
                                >
                                  <div>
                                    <b
                                      style={{
                                        fontSize: 15
                                      }}
                                    >
                                      {shipperApiMsgs &&
                                        shipperApiMsgs.find(
                                          items =>
                                            items.actionByFlag.toLowerCase() ===
                                            'shipper'
                                        )?.actionByName}
                                    </b>
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      textTransform: 'uppercase'
                                    }}
                                  >
                                    {
                                      shipperApiMsgs.find(
                                        items =>
                                          items.actionByFlag.toLowerCase() ===
                                          'shipper'
                                      )?.actionByDesignation
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {carrierRes.actionByFlag.toLowerCase() ===
                            'carrier' && (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'end',
                                marginBottom: 10,
                                textAlign: 'right'
                              }}
                            >
                              <div>
                                <b style={{ fontSize: 15 }}>
                                  {carrierApiMsgs &&
                                    carrierApiMsgs[0]?.actionByName}
                                </b>
                                <br />
                                <span
                                  style={{
                                    fontWeight: 600,
                                    textTransform: 'capitalize'
                                  }}
                                >
                                  {carrierApiMsgs[0]?.actionByDesignation}
                                </span>
                              </div>
                              <div
                                style={{
                                  backgroundColor: '#e0f2f1',
                                  borderRadius: '50%',
                                  width: '45',
                                  height: '45',
                                  textAlign: 'center',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginLeft: 10
                                }}
                              >
                                <Avatar
                                  style={{
                                    borderRadius: '50%',
                                    width: '45',
                                    height: '45',
                                    textAlign: 'center',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    objectFit: 'cover'
                                  }}
                                  alt=''
                                  src={
                                    base_logo_url +
                                    carrierApiMsgs[0]?.actionByImage
                                  }
                                />
                              </div>
                            </div>
                          )}
                          <div
                            style={
                              carrierRes.actionByFlag.toLowerCase() ===
                              'carrier'
                                ? {
                                    marginBottom: '10vh',
                                    background: '#d2f7f2',
                                    color: '#333',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    position: 'relative',
                                    boxShadow:
                                      '0px 4px 12px rgba(0, 0, 0, 0.05)'
                                  }
                                : {
                                    marginBottom: '10vh',
                                    backgroundColor: 'white',
                                    // background:
                                    //   'linear-gradient(135deg, #f1f7fe, #e3ecf7)',
                                    borderRadius: '12px',
                                    padding: '12px 16px',
                                    position: 'relative',
                                    boxShadow:
                                      '0px 4px 12px rgba(0, 0, 0, 0.05)'
                                  }
                            }
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: carrierRes.actionData
                              }}
                            ></div>
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                fontSize: 11
                              }}
                            >
                              {handleDateTimeShow(carrierRes.date, 'time')}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  <div ref={bottomRef} />
                </div>
              </Grid>
              {!isBooked && (
                <div style={{ position: 'relative' }}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    size='small'
                    sx={{
                      mt: 1,
                      backgroundColor: 'f1f7fe',
                      '& .MuiInputBase-root': {
                        display: 'flex',
                        alignItems: 'center',
                        paddingRight: '45px'
                      },
                      '& textarea': {
                        margin: 0,
                        padding: '12px 0 12px 0',
                        display: 'flex',
                        alignItems: 'center'
                      }
                    }}
                    placeholder='Type your message ...'
                    value={userInput}
                    onChange={e => handleUserInput(e.target.value)}
                    onKeyDown={e => handleKeyDown(e, '1stInput')}
                  />

                  {chatLoader ? (
                    <CircularProgress
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 15,
                        transform: 'translateY(-50%)',
                        cursor: 'pointer'
                      }}
                      size={25}
                    />
                  ) : (
                    <IconButton
                      onClick={() => handleShowUserInputMsgs('1stInput')}
                      disabled={userInput === ''}
                      size='small'
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        right: 5,
                        transform: 'translateY(-50%)',
                        color: '#2563eb',
                        width: 40,
                        height: 40,
                        borderRadius: 2
                      }}
                    >
                      <SendOutlinedIcon
                        fontSize='small'
                        sx={{ transform: 'rotate(-45deg)' }}
                      />
                    </IconButton>
                  )}
                </div>
              )}
            </Grid>
          </Grid>
        )
      )}
      {isCancelledCarrier && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 2
          }}
        >
          <Alert
            severity='error'
            icon={<CancelIcon fontSize='inherit' />}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '80%',
              maxWidth: 600,
              borderRadius: 2,
              fontSize: '1.1rem',
              fontWeight: 500,
              textAlign: 'center',
              boxShadow: 3,
              bgcolor: '#ffebee', // light red background
              color: '#b71c1c' // dark red text
            }}
          >
            This shipment has been cancelled.
          </Alert>
        </Box>
      )}

      {isBooked && !isCancelledCarrier && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 2
          }}
        >
          <Alert
            severity={isBookedCarrierSame ? 'success' : 'warning'}
            icon={
              isBookedCarrierSame ? (
                <CheckCircleIcon fontSize='inherit' />
              ) : (
                <WarningAmberIcon fontSize='inherit' />
              )
            }
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '80%',
              maxWidth: 600,
              borderRadius: 2,
              fontSize: '1.1rem',
              fontWeight: 500,
              textAlign: 'center',
              boxShadow: 3,
              bgcolor: isBookedCarrierSame ? '#e8f5e9' : '#fff3e0',
              color: isBookedCarrierSame ? '#1b5e20' : '#e65100'
            }}
          >
            {isBookedCarrierSame
              ? 'This shipment has been booked!'
              : 'This shipment is no longer available.'}
          </Alert>
        </Box>
      )}
    </div>
  );
}
